






























import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { ticketClient } from "@/api/index";
import { GetTicketEstimateReq } from "@/pbjs/external/ticket/ticket_pb";

import { timeFormat } from "@/utils/index.ts";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, setPage, handleResponse } from "@/utils/request";

@Component({
  name: "CombinationProperty"
})
export default class CombinationProperty extends Vue {
  @Provide() private resultData: any = [];
  @Provide() private token: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private searchText: string = "";
  @Provide() private isGetBasicTicketAttrsActionDone: boolean = false;
  @Provide() private pagnition: any = pagnition;

  private created() {
    this.token = localStorage.getItem("token");
    this.getBasicTicketAttrsAction();
  }

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getTicketEstimate();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getTicketEstimate();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getTicketEstimate();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getTicketEstimate();
  }

  private getBasicTicketAttrsAction() {
    this.pageIndex = 1;
    this.getTicketEstimate();
  }
  private getTicketEstimate() {
    let getTicketEstimateCallback = (data: any) => {
        this.resultData = data.dataList;
    };
    let request: any = new GetTicketEstimateReq();
    request.setCommonin(setCommon());
    ticketClient.getTicketEstimate(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        handleResponse(data, getTicketEstimateCallback);   
      }
      if (err) {
          errorMsg(err);
      }
    });
  }
}
